import React from "react";
import { Link } from "react-router-dom";
import styles from "./ClientTopNav.module.css";
import logo from "../../assets/mm-logo.png";

const PHONE_NUMBER = "1300537267"; // 1300 537 267
const PHONE_LABEL = "1300 537 267";
const BOOK_PATH = "/apply"; // internal route

export default function ClientTopNav() {
  return (
    <div className={styles.wrap}>
      <div className={styles.nav}>
        {/* Logo */}
        <Link className={styles.brand} to="/" aria-label="Mortgage Matrix home">
          <img className={styles.logo} src={logo} alt="Mortgage Matrix" />
        </Link>

        <div className={styles.actions}>
          {/* Desktop Phone */}
          <a
            className={`${styles.phonePill} ${styles.hideMobile}`}
            href={`tel:${PHONE_NUMBER}`}
          >
            <span className={styles.icon} aria-hidden>
              📞
            </span>
            {PHONE_LABEL}
          </a>

          {/* Desktop Book */}
          <Link className={`${styles.bookBtn} ${styles.hideMobile}`} to={BOOK_PATH}>
            Book Appointment
          </Link>

          {/* Mobile Phone Icon */}
          <a
            className={`${styles.iconBtn} ${styles.showMobile}`}
            href={`tel:${PHONE_NUMBER}`}
            aria-label="Call Mortgage Matrix"
            title="Call"
          >
            📞
          </a>

          {/* Mobile Book Icon */}
          <Link
            className={`${styles.iconBtn} ${styles.iconBtnBook} ${styles.showMobile}`}
            to={BOOK_PATH}
            aria-label="Book appointment"
            title="Book"
          >
            📅
          </Link>
        </div>
      </div>
    </div>
  );
}